// @ts-strict-ignore
import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMModel } from '@form/model/lm-model';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMModelChangedEvent } from '@form/model';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { LMFormService } from '@form/services/lm-form.service';
import { LMContextService } from '@app/services';
import { LMWebAppService } from "@services/lm-webapp.service";

@Directive({
  selector: '[visiblewhen]' // tslint:disable-line
  })
export class LMVisibleWhenDirective implements OnDestroy, OnInit {
  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;
  @Input() parent: string;
  @Input() isTable: boolean;

  private hasView = false;
  private instanceId: string;
  private subscriptionArray: Array<ISubscription> = [];

  constructor(
    private lmLoggerService: LMLoggerService,
    private lmWebAppService: LMWebAppService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private lmConditionUtilService: LMConditionUtilService,
    private changeDetectorRef: ChangeDetectorRef,
    private lmFormService: LMFormService
  ) {
    this.instanceId = this.lmLoggerService.instanceId;
  }

  ngOnInit() {
    if (!this.layoutObject) {
      return;
    }

    this.evaluateTemplateConditions();

    if (this.layoutObject.visibility) {
      // if there is a visibilty property then listen form model changes so we can
      // update whether it should be displayed in the dom or not.
      this.subscriptionArray.push(
        this.model.modelChanged.subscribe((modelChangedEvent: LMModelChangedEvent) => {
          this.evaluateTemplateConditions();
        })
      );

      this.subscriptionArray.push(
        this.lmConditionUtilService.evaluateConditions.subscribe( (status: boolean) => {
          this.evaluateTemplateConditions();
        })
      );
    }
  }

  ngOnDestroy() {
    // clean up subscriptions
    this.subscriptionArray.forEach(subscription => subscription.unsubscribe());
  }

  private evaluateTemplateConditions() {
    // if no visibility then we still need to display initially.
    // todo: is there a way to not have this directive at all when there is no layoutObject.visiblity
    let valid = true;
    if (this.layoutObject.menuSecurityId && this.lmWebAppService.isPageMenuItemInaccessible(this.layoutObject)) {
      valid = false;
    }

    if (valid) {
      valid = this.layoutObject.visibility ? this.lmConditionUtilService.isValid(this.layoutObject.visibility, this.model) : true;
    }

    if (!this.isTable) {
      if (!this.hasView && valid) {
        // if true, add to dom
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.lmFormService.visibleWhenEvent(this.viewContainer.element);
        // this.lmLoggerService.time('LMVisibleWhen evaluateTemplateConditions() markForCheck() ' + this.layoutObject.id + ' ' + this.instanceId);
        // DETECT CHANGES now markForCheck()
        this.changeDetectorRef.markForCheck();
        // this.lmLoggerService.timeEndCheck('LMVisibleWhen evaluateTemplateConditions() markForCheck() ' + this.layoutObject.id + ' ' + this.instanceId, 200);
        this.hasView = true;

      } else if (this.hasView && !valid) {
        // if false, remove from dom
        this.viewContainer.clear();
        this.lmFormService.visibleWhenEvent(this.viewContainer.element);
        this.hasView = false;
      }
    }

    if (this.isTable) {
      if (!this.hasView && valid) {
        if (this.viewContainer.element.nativeElement
          && this.viewContainer.element.nativeElement.previousElementSibling
          && this.viewContainer.element.nativeElement.previousElementSibling.nodeName === 'TD'
        ) {
          this.viewContainer.element.nativeElement.previousElementSibling.style.visibility = 'visible';
        }

        if (this.viewContainer.length === 0) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.changeDetectorRef.markForCheck();
        }

        this.hasView = true;

      } else if (this.hasView && !valid) {
        if (this.viewContainer.element.nativeElement
          && this.viewContainer.element.nativeElement.previousElementSibling
          && this.viewContainer.element.nativeElement.previousElementSibling.nodeName === 'TD'
        ) {
          this.viewContainer.element.nativeElement.previousElementSibling.style.visibility = 'hidden';
        }

        this.hasView = false;
      }
    }
    if (this.isManualRep()) {
      if (!this.hasView && valid) {
        this.viewContainer.element.nativeElement.previousElementSibling.style.visibility = 'visible';
      } else if (this.hasView && !valid) {
        this.viewContainer.element.nativeElement.previousElementSibling.style.visibility = 'hidden';
      }
    }
  }

  private isManualRep() {
    return this.viewContainer?.element?.nativeElement?.previousElementSibling?.nodeName === "LM-MANUAL-REPRESENTATION";
  }
}
